var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { tracked } from "@glimmer/tracking";
import { getOwner } from "@ember/application";
import { action } from "@ember/object";
import { guidFor } from "@ember/object/internals";
import Service from "@ember/service";
import DMenuInstance from "float-kit/lib/d-menu-instance";
import { updatePosition } from "float-kit/lib/update-position";
let Menu = (_class = class Menu extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "activeMenu", _descriptor, this);
    _initializerDefineProperty(this, "portalOutletElement", _descriptor2, this);
  }
  /**
   * Render a menu
   *
   * @param {Element | DMenuInstance}
   *  - trigger - the element that triggered the menu, can also be an object implementing `getBoundingClientRect`
   *  - menu - an instance of a menu
   * @param {Object} [options] - options
   * @param {String | Element | Component} [options.content] - Specifies the content of the menu
   * @param {Integer} [options.maxWidth] - Specifies the maximum width of the content
   * @param {Object} [options.data] - An object which will be passed as the `@data` argument when content is a `Component`
   * @param {Boolean} [options.arrow] - Determines if the menu has an arrow
   * @param {Boolean} [options.offset] - Displaces the content from its reference trigger in pixels
   * @param {String} [options.identifier] - Add a data-identifier attribute to the trigger and the content
   * @param {Boolean} [options.inline] - Improves positioning for trigger that spans over multiple lines
   *
   * @returns {Promise<DMenuInstance>}
   */
  async show() {
    let instance;
    if (arguments[0] instanceof DMenuInstance) {
      instance = arguments[0];
      if (this.activeMenu === instance && this.activeMenu.expanded) {
        return;
      }
    } else {
      const trigger = arguments[0];
      if (this.activeMenu && this.activeMenu.id === (trigger?.id?.length ? trigger.id : guidFor(trigger)) && this.activeMenu.expanded) {
        this.activeMenu?.close();
        return;
      }
      instance = new DMenuInstance(getOwner(this), trigger, arguments[1]);
    }
    await this.replace(instance);
    instance.expanded = true;
    return instance;
  }

  /**
   * Replaces any active menu-
   */
  async replace(menu) {
    await this.activeMenu?.close();
    this.activeMenu = menu;
  }

  /**
   * Closes the active menu
   * @param {DMenuInstance} [menu] - the menu to close, if not provider will close any active menu
   */
  async close(menu) {
    if (this.activeMenu && menu && this.activeMenu.id !== menu.id) {
      return;
    }
    await this.activeMenu?.close();
    this.activeMenu = null;
  }

  /**
   * Update the menu position
   * @param {DMenuInstance} [menu] - the menu to update, if not provider will update any active menu
   */
  async update(menu) {
    const instance = menu || this.activeMenu;
    if (!instance) {
      return;
    }
    await updatePosition(instance.trigger, instance.content, instance.options);
    await instance.show();
  }

  /**
   * Register event listeners on a trigger to show a menu
   *
   * @param {Element} trigger - the element that triggered the menu, can also be an object implementing `getBoundingClientRect`
   * @param {Object} [options] - @see `show`
   *
   * @returns {DMenuInstance} An instance of the menu
   */
  register(trigger, options = {}) {
    return new DMenuInstance(getOwner(this), trigger, {
      ...options,
      listeners: true,
      beforeTrigger: async menu => {
        await this.replace(menu);
      }
    });
  }
  registerPortalOutletElement(element) {
    this.portalOutletElement = element;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "activeMenu", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "portalOutletElement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "show", [action], Object.getOwnPropertyDescriptor(_class.prototype, "show"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "replace", [action], Object.getOwnPropertyDescriptor(_class.prototype, "replace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "register", [action], Object.getOwnPropertyDescriptor(_class.prototype, "register"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerPortalOutletElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerPortalOutletElement"), _class.prototype)), _class);
export { Menu as default };